var map = {
	"./loginlogo.svg": "C9/D",
	"./logo_ats.png": "MGdV",
	"./logo_fpt.png": "6zy7"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "C4Lc";


//////////////////
// WEBPACK FOOTER
// ./src/customization/SteelOApp/pages/Login/Assets/Img ^\.\/.*$
// module id = C4Lc
// module chunks = 0